import { Timer } from "three/src/core/Timer.js";

export function createRenderLoop(update, targetDocument = document) {
  const timer = new Timer();
  const targetWindow = targetDocument.defaultView ?? window;
  let frameId = null;
  let running = false;

  timer.connect(targetDocument);

  function tick() {
    if (!running) return;

    timer.update();
    update(timer.getDelta());
    frameId = targetWindow.requestAnimationFrame(tick);
  }

  return {
    start() {
      if (running) return;
      running = true;
      tick();
    },
    stop() {
      running = false;
      if (frameId !== null) targetWindow.cancelAnimationFrame(frameId);
      frameId = null;
      timer.disconnect();
    },
  };
}
